module.exports = __webpack_public_path__ + "static/img/img_empty.fd7ae94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demand/img_empty.png
// module id = Eowh
// module chunks = 1